import React from "react";
import { connect } from "react-redux";
import { translations } from "../../../config.js";
import { message, setCurrentShow, setHistoryRoute, setTitleAndScrollToTop } from "../../../actions";
import { getQuestionnairesOverview, deleteQuestionnaires, downloadQuestionnaire, activateQuestionnaires } from "../actions/Questionnaires.js";
import { Link, withRouter } from "react-router-dom";
import Icon from "../../../components/Icon";
import Access from "../../../components/Access";
import ReactGA from "react-ga";
import Overview from "../../../components/Overview";

const mapStateToProps = ( state ) =>
{
	return {
		questionnairesOverview: state.questionnairesOverview
	};
};

const mapDispatchToProps = ( dispatch ) =>
{
	return {
		getQuestionnairesOverview: () =>
		{
			dispatch( getQuestionnairesOverview() );
		},
		deleteQuestionnaires: ( a_id ) =>
		{
			dispatch( deleteQuestionnaires( a_id ) );
		},
		downloadQuestionnaire: ( a_id, a_format ) =>
		{
			dispatch( downloadQuestionnaire( a_id, a_format ) );
		},
		activateQuestionnaires: ( a_formData ) =>
		{
			dispatch( activateQuestionnaires( a_formData ) );
		},
		setTitleAndScrollToTop: ( a_title ) =>
		{
			dispatch( setTitleAndScrollToTop( a_title ) );
		},
		setCurrentShow: ( a_show ) =>
		{
			dispatch( setCurrentShow( a_show ) );
		},
		setHistoryRoute: ( a_route ) =>
		{
			dispatch( setHistoryRoute( a_route ) );
		},
		message: ( a_message, a_type, a_timeout ) =>
		{
			dispatch( message( a_message, a_type, a_timeout ) );
		}
	};
};

/**
 * Fragebogenkomponente der GUI
 */
class QuestionnairesOverview extends React.Component
{
	constructor( props )
	{
		super( props );
		
		this.handleSubmit = this.handleSubmit.bind( this );
		this.handleExport = this.handleExport.bind( this );
		
	} // function constructor(...)
	
	componentDidMount()
	{
		this.props.setTitleAndScrollToTop( `${translations.de_DE.words.questionnairesOverview}` );
		this.props.setCurrentShow( "QuestionnairesOverviewAdmin" );
		this.props.getQuestionnairesOverview();
		
		// Google Analytics
		if ( localStorage.getItem( "ga" ) )
		{
			ReactGA.pageview( translations.de_DE.routes.questionnaires );
		}
		
	} // function componentDidMount()
	
	handleSubmit( event, id, mode )
	{
		switch ( mode )
		{
			case "delete":
				this.props.deleteQuestionnaires( id );
				break;
			
			default:
				break;
		}
		
		event.preventDefault();
		
	} // function handleSubmit(...)
	
	handleExport( a_event, a_questionnaire_id, a_format )
	{
		this.props.downloadQuestionnaire( a_questionnaire_id, a_format );
		
		a_event.preventDefault();
		
	} // function handleExport(...)
	
	handleDelete( questionnaire )
	{
		this.props.deleteQuestionnaires( questionnaire.id );
		
	} // function handleDelete()
	
	handleEdit( questionnaire )
	{
		this.props.history.push( `${translations.de_DE.routes.questionnaire}/${questionnaire.id}` );
		
	} // function handleEdit(...)
	
	handleTestSurvey( questionnaire )
	{
		this.props.setHistoryRoute( this.props.location.pathname );
		this.props.history.push( `${translations.de_DE.routes.surveyTest}?id=${questionnaire.id}` );
		
	} // function handleTestSurvey(...)
	
	handleActivate( questionnaire )
	{
		this.props.activateQuestionnaires( questionnaire );
		
	} // function handleActivate(...)
	
	handleExportPDF( questionnaire )
	{
		this.props.downloadQuestionnaire( questionnaire.id, "pdf" );
		
	} // function handleExportPDF(...)
	
	render()
	{
		const { questionnairesOverview } = { ...this.props };
		
		return <article>
			<section className={"white"}>
				<div className={"col s12 tRight"}>
					<Access permissions={[ "create_questionnaire" ]}>
						<Link className={"btn icon-shadow margin-top btn-right-space"}
						      key={`new_questionnaire`}
						      to={`${translations.de_DE.routes.questionnaire}`}
						>
							<Icon iconName={"add"}/><span>{translations.de_DE.words.questionnaire} erstellen</span>
						</Link>
					</Access>
				</div>
				<div className={"col s12"}>
					{
						questionnairesOverview &&
						<Overview title={translations.de_DE.words.questionnairesOverview}
						          list={questionnairesOverview}
						          classNameItem={"white-grey"}
						          classNameDataBlock={"col s12 l10 unset-padding"}
						          classNameTriggerBlock={"col s12 l2 tRight"}
						          permissionsToShow={[ "get_questionnaires" ]}
						          listFields={[
							          {
								          type: "title",
								          title: "Titel",
								          className: "col s12 m6 l4 xl3"
							          },
							          {
								          type: "law",
								          title: "Norm",
								          className: "col s12 m6 l6 xl3"
							          },
							          {
								          type: "description",
								          title: "Beschreibung",
								          className: "col s12 m6 l6 xl4"
							          },
							          {
								          type: "price",
								          title: "Preis pro Recherche",
								          className: "col s12 m6 l4 xl2",
								          format: "price",
								          cleared: true
							          }
						          ]}
						          trigger={[
							          {
								          key: "edit",
								          icon: "edit",
								          iconTitle: `${translations.de_DE.words.questionnaire} bearbeiten`,
								          iconClassName: "white primary-color-text hover-primary-color hover-white-text",
								          permissions: [ "patch_questionnaire" ],
								          confirm: false,
								          onClick: this.handleEdit.bind( this )
							          },
							          {
								          key: "app_test",
								          icon: "test",
								          iconTitle: `${translations.de_DE.words.questionnaire} testen`,
								          iconClassName: "white primary-color-text hover-primary-color hover-white-text",
								          permissions: [ "test_survey" ],
								          confirm: false,
								          onClick: this.handleTestSurvey.bind( this )
							          },
							          {
								          key: [ "unchecked", "checked" ],
								          icon: [ "unchecked", "checked" ],
								          fieldName: { key: "active", value: "1" },
								          iconTitle: [ `${translations.de_DE.words.questionnaire} aktivieren`, `${translations.de_DE.words.questionnaire} deaktivieren` ],
								          iconClassName: [
									          "white primary-color-text hover-primary-color hover-white-text",
									          "white green-text hover-green hover-white-text"
								          ],
								          permissions: [ "patch_questionnaire" ],
								          confirm: false,
								          onClick: this.handleActivate.bind( this )
							          },
							          {
								          key: "pdf",
								          icon: "pdf",
								          iconTitle: "PDF erzeugen",
								          iconClassName: "white primary-color-text hover-primary-color hover-white-text",
								          permissions: [ "export_questionnaire" ],
								          confirm: false,
								          onClick: this.handleExportPDF.bind( this )
							          },
							          {
								          key: "delete",
								          icon: "delete",
								          submitButtonText: "Ja",
								          cancelButtonText: "Nein",
								          iconTitle: `${translations.de_DE.words.questionnaire} löschen`,
								          iconClassName: "white red-text hover-red hover-white-text",
								          permissions: [ "delete_questionnaire" ],
								          submitText: `Soll die ${translations.de_DE.words.questionnaire} gelöscht werden?`,
								          onClick: this.handleDelete.bind( this )
							          }
						          ]}
						/>
					}
				</div>
			</section>
		</article>;
		
	} // function render()
	
} // class

QuestionnairesOverview = connect(
	mapStateToProps,
	mapDispatchToProps
)( QuestionnairesOverview );

export default withRouter( QuestionnairesOverview );